import { device } from '@ui-components/breakpoints';
import {
    cookieGreen1,
    cookieGreen2,
    cookieYellow1,
    playTransitionCubicEaseInOut,
    regularWhite,
} from '@ui-components/design-tokens';
import PlayButton from '@ui-components/PlayButton';
import { playFontSize } from '@ui-components/typography/helpers';
import { playFocus } from '@ui-components/utils.styles';
import styled, { css, keyframes } from 'styled-components';

const animateIn = keyframes`
    0% {
        transform: translateY(20px);
        opacity: 0;
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
`;

export const StyledCookieConsent = styled.div<{
    small?: boolean;
    smallMaxHeight?: boolean;
    tallHeight: boolean;
}>`
    width: 100%;
    max-width: 100%;
    height: 100%;
    position: fixed;
    background-color: ${cookieGreen1};
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    outline: 0;
    justify-content: space-between;

    ${({ smallMaxHeight }) =>
        smallMaxHeight &&
        css`
            max-height: 350px;
            justify-content: center;
        `}

    &::-webkit-scrollbar {
        background-color: rgba(255, 255, 255, 0.1);
        width: 10px;
        border-radius: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: rgba(100, 100, 100, 0.9);
        border-radius: 5px;
    }

    overflow-y: auto;

    @media ${device.GteSmall} {
        animation: ${animateIn} 400ms ${playTransitionCubicEaseInOut};
        height: ${({ tallHeight }) => (tallHeight ? '680px' : '560px')};
        width: 600px;
        max-height: ${({ smallMaxHeight }) => (smallMaxHeight ? '350px' : '80%')};
        max-width: calc(100% - 20px);
        overflow-y: hidden;
    }
`;

export const StyledCookieContainer = styled.div`
    display: flex;
    position: fixed;
    width: 100%;
    height: 100%;
    height: calc(100vh - env(safe-area-inset-bottom));
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.85);
    z-index: 998;
    align-items: center;
    justify-content: space-around;
    overflow: hidden;
`;

export const StyledCookieConsentLogo = styled.div<{ isHidden: boolean }>`
    width: 44px;
    align-self: flex-end;

    ${({ isHidden }) =>
        isHidden &&
        css`
            display: none;
        `}
`;

export const StyledCookieConsentHeader = styled.h1`
    ${playFontSize(2.6)};
    color: ${cookieYellow1};
    margin-bottom: 20px;
`;

export const StyledCookieConsentTextArea = styled.div`
    @media ${device.GteMedium} {
        flex-direction: row;
    }
`;

export const StyledCookieConsentDescription = styled.p`
    ${playFontSize(1.4)};
    line-height: 1.43;
    color: ${regularWhite};
    margin-bottom: 25px;
`;

export const StyledCookieConsentParagraph = styled.p`
    ${playFontSize(1.4)};
    line-height: 1.43;
    color: ${regularWhite};
    margin-bottom: 20px;
`;

export const StyledCookieConsentActions = styled.div`
    width: 100%;
    background-color: ${cookieGreen2};
    display: inline-flex;
    box-sizing: border-box;
    padding: 30px 20px;
    justify-content: space-around;
    flex-direction: column-reverse;

    @media ${device.GteSmall} {
        padding: 30px 40px;
        flex-direction: row;
        position: sticky;
    }
`;

export const StyledCookieConsentButton = styled(PlayButton)`
    margin-bottom: 10px;
    ${playFocus(2)}

    @media ${device.GteSmall} {
        margin-bottom: 0px;
    }
`;

export const StyledCookieConsentSettings = styled.div<{ centerContent?: boolean }>`
    display: inline-flex;
    flex-direction: column;
    padding: 20px 20px 20px;

    @media ${device.GteSmall} {
        padding: 20px 40px 20px;
        overflow-y: auto;
        overflow-y: overlay;
        height: 100%;
    }

    ${({ centerContent }) =>
        centerContent &&
        css`
            justify-content: center;
            overflow-y: hidden;
        `}

    &::-webkit-scrollbar {
        background-color: rgba(255, 255, 255, 0.1);
        width: 10px;
        border-radius: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: rgba(100, 100, 100, 0.9);
        border-radius: 5px;
    }
`;

export const StyledCookieConsentBalk = styled.div<{ isHidden: boolean }>`
    display: inline-flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 40px;
    align-items: center;

    ${({ isHidden }) =>
        isHidden &&
        css`
            display: none;
        `}
`;
